<template>
  <div v-if="isPromptActiveLocal ? true : false">questions</div>
</template>

<script>
export default {
  name: "Otd2AddEvaluationQuestions",

  data() {
    return {};
  },
  props: {
    isPromptActive: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    isPromptActive(val) {
      if (!val) return;
    },
  },
  computed: {
    isPromptActiveLocal: {
      get() {
        if (this.isPromptActive) {
        }
        return this.isPromptActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closePrompt");
        }
      },
    },
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
</style>